import {
  Avatar,
  Container,
  Group,
  Paper,
  rem,
  SimpleGrid,
  Text,
  Title,
} from "@mantine/core";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

// const testimonials = [
//   {
//     name: "Jessica R.",
//     role: "Lifestyle Creator",
//     avatar: "https://randomuser.me/api/portraits/women/68.jpg",
//     content:
//       "Collabish made it so easy to find brands that align with my values. I've had my most successful collaborations through this platform!",
//   },
//   {
//     name: "Mike L.",
//     role: "Tech Reviewer",
//     avatar: "https://randomuser.me/api/portraits/men/32.jpg",
//     content:
//       "The transparency and direct communication on Collabish are game-changers. No more endless email chains and confusing terms.",
//   },
//   {
//     name: "Sarah P.",
//     role: "Brand Manager, Aura Beauty",
//     avatar: "https://randomuser.me/api/portraits/women/44.jpg",
//     content:
//       "We've discovered amazing creators who have generated authentic, high-performing content for our campaigns. Highly recommended!",
//   },
// ];

const testimonials = [
  {
    name: "Jane Doe",
    role: "Example Creator",
    avatar: "https://via.placeholder.com/150",
    content:
      "[Placeholder testimonial - This is sample text that will be replaced with real user feedback in the future.]",
  },
  {
    name: "John Smith",
    role: "Sample Brand Manager",
    avatar: "https://via.placeholder.com/150",
    content:
      "[Placeholder testimonial - This is sample text that will be replaced with real user feedback in the future.]",
  },
  {
    name: "Alex Johnson",
    role: "Demo User",
    avatar: "https://via.placeholder.com/150",
    content:
      "[Placeholder testimonial - This is sample text that will be replaced with real user feedback in the future.]",
  },
];

export function Testimonials() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { x: -20, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <Container size="lg" ref={ref}>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
      >
        <Title
          order={2}
          ta="center"
          style={{ fontSize: rem(40), marginBottom: rem(40) }}
        >
          Loved by Creators and Brands
        </Title>
        <SimpleGrid cols={{ base: 1, md: 3 }} spacing="xl">
          {testimonials.map((testimonial) => (
            <motion.div key={testimonial.name} variants={itemVariants}>
              <Paper
                p="xl"
                radius="lg"
                shadow="md"
                withBorder
                style={{ height: "100%" }}
              >
                <Group>
                  <Avatar
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    radius="xl"
                    size="lg"
                  />
                  <div>
                    <Text fw={500}>{testimonial.name}</Text>
                    <Text size="sm" c="dimmed">
                      {testimonial.role}
                    </Text>
                  </div>
                </Group>
                <Text mt="md" size="sm">
                  “{testimonial.content}”
                </Text>
              </Paper>
            </motion.div>
          ))}
        </SimpleGrid>
      </motion.div>
    </Container>
  );
}
